import { render, staticRenderFns } from "./Artist.html?vue&type=template&id=1f7c79e4&scoped=true&"
import script from "./Artist.ts?vue&type=script&lang=ts&"
export * from "./Artist.ts?vue&type=script&lang=ts&"
import style0 from "./Artist.css?vue&type=style&index=0&id=1f7c79e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7c79e4",
  null
  
)

export default component.exports